<template>
  <div>
    <div>
      <notice-staff></notice-staff>
    </div>
    <div style="margin-bottom: 10px" class="df both-side">
      <a-select
        :options="selectOptions"
        v-model:value="selectProject"
        @change="handleSelectProject"
        placeholder="请选择项目"
        style="width: 200px"
        allowClear
      >
      </a-select>
      <a-button @click="handleUpdateProject(null)" size="small" type="primary">新增</a-button>
    </div>

    <a-table
      :data-source="showTableData"
      bordered
      :pagination="false"
      :columns="columns"
      :scroll="{
        y: 'calc(100vh - 300px)',
      }"
      rowKey="id"
    >
      <template #action="{ record }">
        <a-space>
          <a-button
            @click="handleUpdateProject(record)"
            size="small"
            v-if="record.userId === user.id || user.id === 5"
            >修改</a-button
          >
          <a-button @click="handleProjectDetails(record)" size="small" 
            type="primary">
            项目详情
          </a-button>

          <!-- <a-button
            @click="handleDeleteProject(record)"
            size="small"
            type="danger"
            v-if="record.userId === user.id"
            >删除</a-button
          > -->
        </a-space>
      </template>
    </a-table>

    <project-form ref="projectFormRef" @updateTable="getData()"></project-form>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onBeforeUpdate,
  provide,
  ref,
  watch,
} from "vue";
import {
  getProjectLifeCycle,
  deleteProjectLifeCycle,
} from "@/request/view/project";
import { useTable } from "@/views/notice/serve/table";
import { onBeforeRouteLeave, useRoute, useRouter } from "vue-router";
import projectForm from "@/views/rdmanagement/components/project/form.vue";
import noticeStaff from "@/components/chooseStaff/index.vue";
import { useStore } from "vuex";

export default defineComponent({
  components: { projectForm, noticeStaff },
  setup() {
    const router = useRouter();
    const user = useStore().state.user.user;
    const store = useStore();
    const isProjectLear = ref(false);

    provide("isProjectLear", isProjectLear);

    const selectProject = ref(null);

    const selectOptions = ref([]);
    const showTableData = computed(() =>
      table.data.filter((r) => r.id === selectProject.value)
    );

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({});

    const projectFormRef = ref();

    const columns = [
      {
        title: "项目名称",
        dataIndex: "project",
        align: "center",
      },
      {
        title: "项目简称",
        dataIndex: "projectAS",
        align: "center",
      },
      {
        title: "阶段",
        dataIndex: "projectLifeCycle",
        align: "center",
      },
      {
        title: "状态",
        dataIndex: "projectStatus",
        align: "center",
      },
      {
        title: "项目负责人",
        dataIndex: "username",
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        align: "center",
      },
    ];

    requestConfig.pull_fn = getProjectLifeCycle;
    requestConfig.delete_fn = deleteProjectLifeCycle;

    const handleUpdateProject = (record) => {
      projectFormRef.value.showModal({
        type: record === null ? "insert" : "update",
        title: record === null ? "新增项目" : "修改项目",
        data: record,
      });
    };

    const handleProjectDetails = (record) => {
      isProjectLear.value = user.nickName === record.username;
      router.push({
        path: "/rdprojectlayout",
        query: {
          userId: record.userId,
          projectId: record.id,
          projectAS: record.projectAS,
          projectLifeCycle: record.projectLifeCycle,
          projectLeader: record.username,
          projectName: record.project,
        },
      });
    };

    const handleSelectProject = (e) => {
      if (e) {
        const projectName = table.data.find((r) => r.id === e).project;
        store.commit("SET_PROJECT_NAME", projectName);
      }
    };

    const getData = () => {
      getListData({ unPagingRequest: true }).then(() => {
        selectOptions.value.length = 0;
        table.data.forEach((item) => {
          selectOptions.value.push({
            label: item.project,
            value: item.id,
          });
        });
        if (store.state.project) {
          selectProject.value = table.data.find(
            (r) => r.project === store.state.project
          ).id;
        }
      });
    };

    const handleDeleteProject = (record) => {
      deleteRecords([record.id], { title: "确认删除？" }).then(() => {
        getData();
      });
    };

    getData();

    return {
      table,
      columns,
      user,
      handleSelectProject,
      selectOptions,
      projectFormRef,
      showTableData,
      selectProject,
      getData,
      handleDeleteProject,
      handleProjectDetails,
      handleUpdateProject,
    };
  },
});
</script>

<style lang="less" scoped>
::v-deep .ant-empty-normal {
  margin: 0 auto !important;
}
::v-deep .ant-table-placeholder {
  padding: 0 !important;
}
</style>
